module.exports = __webpack_public_path__ + "img/invoice-bill-svgrepo-com.e1626eb4.svg";